module.exports = __webpack_public_path__ + "static/media/post-img2.f97e894c.jpg";